import type { ReactNode } from 'react';

/** Column span on the 12-column desktop grid; every card is full width on phones (NFR-23). */
export type ProfileCardSpan = 4 | 5 | 6 | 7 | 8 | 12;

// Literal class names: Tailwind only generates classes it can find verbatim.
const SPAN_CLASS: Record<ProfileCardSpan, string> = {
  4: 'lg:col-span-4',
  5: 'lg:col-span-5',
  6: 'lg:col-span-6',
  7: 'lg:col-span-7',
  8: 'lg:col-span-8',
  12: 'lg:col-span-12',
};

/** The card grid under the profile header (FR-165). */
export function ProfileCardGrid({ children }: { children: ReactNode }) {
  return <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">{children}</div>;
}

/** One cell of `ProfileCardGrid`, sized by `span`. */
export function ProfileGridItem({
  span,
  children,
}: {
  span: ProfileCardSpan;
  children: ReactNode;
}) {
  return <div className={`min-w-0 ${SPAN_CLASS[span]} [&>*]:h-full`}>{children}</div>;
}
